// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MasterDetailLayout-module__font-s-10___f1kkZ {
  font-size: 10px !important;
}

.MasterDetailLayout-module__font-s-12___KEUFA {
  font-size: 12px !important;
}

.MasterDetailLayout-module__font-s-13___H9nCJ {
  font-size: 13px !important;
}

.MasterDetailLayout-module__font-s-14___L398y {
  font-size: 14px !important;
}

.MasterDetailLayout-module__font-s-15___qLhhG {
  font-size: 15px !important;
}

.MasterDetailLayout-module__font-s-16___gOVQ2 {
  font-size: 16px !important;
}

.MasterDetailLayout-module__font-s-18___FQDdp {
  font-size: 18px !important;
}

.MasterDetailLayout-module__font-s-20___xmutO {
  font-size: 20px !important;
}

.MasterDetailLayout-module__font-s-22___Gwpuy {
  font-size: 22px !important;
}

.MasterDetailLayout-module__font-s-28___NPkrS {
  font-size: 28px !important;
}

.MasterDetailLayout-module__font-w-400___pu2af {
  font-weight: 400 !important;
}

.MasterDetailLayout-module__font-w-500___lurSk {
  font-weight: 500 !important;
}

.MasterDetailLayout-module__font-w-600___bBvKj {
  font-weight: 600 !important;
}

.MasterDetailLayout-module__font-w-700___JD3sY {
  font-weight: 700 !important;
}

.MasterDetailLayout-module__p-5___zUOlF {
  padding: 5px !important;
}

.MasterDetailLayout-module__p-12___RUNEr {
  padding: 12px !important;
}

.MasterDetailLayout-module__p-16___ombPw {
  padding: 16px !important;
}

.MasterDetailLayout-module__p-30___BlgYu {
  padding: 30px !important;
}

.MasterDetailLayout-module__p-b-0___zqGoH {
  padding-bottom: 0 !important;
}

.MasterDetailLayout-module__p-b-5___N3hvW {
  padding-bottom: 5px !important;
}

.MasterDetailLayout-module__p-b-10___mHcw8 {
  padding-bottom: 10px !important;
}

.MasterDetailLayout-module__p-b-12___XZomc {
  padding-bottom: 12px !important;
}

.MasterDetailLayout-module__p-b-16___U7GKR {
  padding-bottom: 16px !important;
}

.MasterDetailLayout-module__p-b-18___EPefQ {
  padding-bottom: 18px !important;
}

.MasterDetailLayout-module__p-b-20___AkqLG {
  padding-bottom: 20px !important;
}

.MasterDetailLayout-module__p-b-25___pSPzm {
  padding-bottom: 25px !important;
}

.MasterDetailLayout-module__p-b-30___kCfnj {
  padding-bottom: 30px !important;
}

.MasterDetailLayout-module__p-b-50___W9nqT {
  padding-bottom: 50px !important;
}

.MasterDetailLayout-module__p-t-0___S8rGP {
  padding-top: 0 !important;
}

.MasterDetailLayout-module__p-t-12___vDThY {
  padding-top: 12px !important;
}

.MasterDetailLayout-module__p-t-16___SUV1J {
  padding-top: 16px !important;
}

.MasterDetailLayout-module__p-t-18___A4Q0p {
  padding-top: 18px !important;
}

.MasterDetailLayout-module__p-t-20___lwq2n {
  padding-top: 20px !important;
}

.MasterDetailLayout-module__p-t-30___XUNK0 {
  padding-top: 30px !important;
}

.MasterDetailLayout-module__p-t-40___fL79s {
  padding-top: 40px !important;
}

.MasterDetailLayout-module__p-t-50___SVOhH {
  padding-top: 50px !important;
}

.MasterDetailLayout-module__p-l-20___2G5Xz {
  padding-left: 20px !important;
}

.MasterDetailLayout-module__p-l-30___nVThM {
  padding-left: 30px !important;
}

.MasterDetailLayout-module__p-l-40___tAIYC {
  padding-left: 40px !important;
}

.MasterDetailLayout-module__p-r-16___xXowR {
  padding-right: 16px !important;
}

.MasterDetailLayout-module__p-r-20___bqeVi {
  padding-right: 20px !important;
}

.MasterDetailLayout-module__p-r-30___oTbdU {
  padding-right: 30px !important;
}

.MasterDetailLayout-module__p-r-50___wBLDg {
  padding-right: 50px !important;
}

.MasterDetailLayout-module__p-r-60___K1js5 {
  padding-right: 60px !important;
}

.MasterDetailLayout-module__m-b-1___FAeZX {
  margin-bottom: 1px !important;
}

.MasterDetailLayout-module__m-b-2___WuxGO {
  margin-bottom: 2px !important;
}

.MasterDetailLayout-module__m-b-6___sy49I {
  margin-bottom: 6px !important;
}

.MasterDetailLayout-module__m-b-8___SL7z2 {
  margin-bottom: 8px !important;
}

.MasterDetailLayout-module__m-b-10___R9Xby {
  margin-bottom: 10px !important;
}

.MasterDetailLayout-module__m-b-14___ZEW3V {
  margin-bottom: 14px !important;
}

.MasterDetailLayout-module__m-b-16___xXX9X {
  margin-bottom: 16px !important;
}

.MasterDetailLayout-module__m-b-20___Ib3q9 {
  margin-bottom: 20px !important;
}

.MasterDetailLayout-module__m-b-22___YZQS9 {
  margin-bottom: 22px !important;
}

.MasterDetailLayout-module__m-b-24___yYVnP {
  margin-bottom: 24px !important;
}

.MasterDetailLayout-module__m-b-30___r6EBj {
  margin-bottom: 30px !important;
}

.MasterDetailLayout-module__m-b-32___u8gcs {
  margin-bottom: 32px !important;
}

.MasterDetailLayout-module__m-b-40___TNqM9 {
  margin-bottom: 40px !important;
}

.MasterDetailLayout-module__m-t-2___RaZ6r {
  margin-top: 2px !important;
}

.MasterDetailLayout-module__m-t-3___b4pka {
  margin-top: 3px !important;
}

.MasterDetailLayout-module__m-t-4___B4kW4 {
  margin-top: 4px !important;
}

.MasterDetailLayout-module__m-t-5___RqwPD {
  margin-top: 5px !important;
}

.MasterDetailLayout-module__m-t-8___w7FjC {
  margin-top: 8px !important;
}

.MasterDetailLayout-module__m-t-10___Q9qMq {
  margin-top: 10px !important;
}

.MasterDetailLayout-module__m-t-15___XBDbF {
  margin-top: 15px !important;
}

.MasterDetailLayout-module__m-t-16___jcIro {
  margin-top: 16px !important;
}

.MasterDetailLayout-module__m-t-20___UVVVz {
  margin-top: 20px !important;
}

.MasterDetailLayout-module__m-t-22___BgJpP {
  margin-top: 22px !important;
}

.MasterDetailLayout-module__m-t-30___I8yc7 {
  margin-top: 30px !important;
}

.MasterDetailLayout-module__m-t-32___y7642 {
  margin-top: 32px !important;
}

.MasterDetailLayout-module__m-l-auto___OiuJx {
  margin-left: auto !important;
}

.MasterDetailLayout-module__m-l-4___RTR0L {
  margin-left: 4px !important;
}

.MasterDetailLayout-module__m-l-5___tZlnv {
  margin-left: 5px !important;
}

.MasterDetailLayout-module__m-l-6___TWMBU {
  margin-left: 6px !important;
}

.MasterDetailLayout-module__m-l-8___TKU6M {
  margin-left: 8px !important;
}

.MasterDetailLayout-module__m-l-10___KuYbR {
  margin-left: 10px !important;
}

.MasterDetailLayout-module__m-l-16___wobCp {
  margin-left: 16px !important;
}

.MasterDetailLayout-module__m-l-20____XmW9 {
  margin-left: 20px !important;
}

.MasterDetailLayout-module__m-l-24___YnAYn {
  margin-left: 24px !important;
}

.MasterDetailLayout-module__m-l-30___Jce01 {
  margin-left: 30px !important;
}

.MasterDetailLayout-module__m-l-35___GcBXg {
  margin-left: 35px !important;
}

.MasterDetailLayout-module__m-l-40___owmNV {
  margin-left: 40px !important;
}

.MasterDetailLayout-module__m-r-8___gaIao {
  margin-right: 8px !important;
}

.MasterDetailLayout-module__m-r-10___HfTJP {
  margin-right: 10px !important;
}

.MasterDetailLayout-module__m-r-16___zUffO {
  margin-right: 16px !important;
}

.MasterDetailLayout-module__m-r-20___qpjXy {
  margin-right: 20px !important;
}

.MasterDetailLayout-module__m-r-24___S9uiy {
  margin-right: 24px !important;
}

.MasterDetailLayout-module__m-r-30___dWTgZ {
  margin-right: 30px !important;
}

.MasterDetailLayout-module__m-r-40___f_OTK {
  margin-right: 40px !important;
}

.MasterDetailLayout-module__border-r-3___BdtmV {
  border-radius: 3px !important;
}

.MasterDetailLayout-module__border-r-4___xKZ9w {
  border-radius: 4px !important;
}

.MasterDetailLayout-module__border-r-6___drQSu {
  border-radius: 6px !important;
}

.MasterDetailLayout-module__border-r-10___xykr6 {
  border-radius: 10px !important;
}

.MasterDetailLayout-module__border-r-12___zUC50 {
  border-radius: 12px !important;
}

.MasterDetailLayout-module__border-r-16___J5Xny {
  border-radius: 16px !important;
}

.MasterDetailLayout-module__border-r-50___qRcaH {
  border-radius: 50% !important;
}

.MasterDetailLayout-module__primary-border___nBNRR {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterDetailLayout-module__primary-border-b___mmyIt {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterDetailLayout-module__primary-border-t___RzGGx {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterDetailLayout-module__primary-border-l___sI5fc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterDetailLayout-module__primary-border-r___KEjr8 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MasterDetailLayout-module__secondary-border___gUZup {
  border: 1px solid #637768;
}

.MasterDetailLayout-module__secondary-border-b___Kl7X4 {
  border-bottom: 1px solid #637768;
}

.MasterDetailLayout-module__secondary-border-t___Ffs92 {
  border-top: 1px solid #637768;
}

.MasterDetailLayout-module__secondary-border-l___Yp_L1 {
  border-left: 1px solid #637768;
}

.MasterDetailLayout-module__secondary-border-r___O1tK2 {
  border-right: 1px solid #637768;
}

.MasterDetailLayout-module__gap-0___MZ1Fi {
  gap: 0 !important;
}

.MasterDetailLayout-module__gap-2___a2r1I {
  gap: 2px !important;
}

.MasterDetailLayout-module__gap-4___DHbsI {
  gap: 4px !important;
}

.MasterDetailLayout-module__gap-5___KpdP0 {
  gap: 5px !important;
}

.MasterDetailLayout-module__gap-6___xqf09 {
  gap: 6px !important;
}

.MasterDetailLayout-module__gap-8___jxSro {
  gap: 8px !important;
}

.MasterDetailLayout-module__gap-10___aFISO {
  gap: 10px !important;
}

.MasterDetailLayout-module__gap-12___tKbf4 {
  gap: 12px !important;
}

.MasterDetailLayout-module__gap-14___epr_g {
  gap: 14px !important;
}

.MasterDetailLayout-module__gap-16___PkM5W {
  gap: 16px !important;
}

.MasterDetailLayout-module__gap-18___ocETe {
  gap: 18px !important;
}

.MasterDetailLayout-module__gap-20___ukaq2 {
  gap: 20px !important;
}

.MasterDetailLayout-module__gap-24___stBTH {
  gap: 24px !important;
}

.MasterDetailLayout-module__gap-26___ps_pV {
  gap: 26px !important;
}

.MasterDetailLayout-module__gap-30___ppLuj {
  gap: 30px !important;
}

.MasterDetailLayout-module__gap-32___Mt4xs {
  gap: 32px !important;
}

.MasterDetailLayout-module__gap-40___nB7yV {
  gap: 40px !important;
}

.MasterDetailLayout-module__gap-50___jmWRf {
  gap: 50px !important;
}

.MasterDetailLayout-module__flex-1___D4Klu {
  flex: 1;
}

.MasterDetailLayout-module__flex-none___h2gWh {
  flex: none !important;
}

.MasterDetailLayout-module__flex-column___wUeUu {
  display: flex;
  flex-direction: column !important;
}

.MasterDetailLayout-module__flex-row___M5KsP {
  display: flex;
  flex-direction: row !important;
}

.MasterDetailLayout-module__vertically-centered___qG8Ka {
  display: flex;
  align-items: center !important;
}

.MasterDetailLayout-module__horizontally-centered___B84NG {
  display: flex;
  justify-content: center !important;
}

.MasterDetailLayout-module__horizontally-end___E2KUq {
  display: flex;
  justify-content: end !important;
}

.MasterDetailLayout-module__vertically-start___qy6kb {
  display: flex;
  align-items: start !important;
}

.MasterDetailLayout-module__space-between___Hza4e {
  display: flex;
  justify-content: space-between !important;
}

.MasterDetailLayout-module__flex-wrap___S6uOF {
  flex-wrap: wrap !important;
}

.MasterDetailLayout-module__height-100___eEAYm {
  height: 100%;
}

.MasterDetailLayout-module__width-50___v9L8U {
  width: 50% !important;
}

.MasterDetailLayout-module__width-100___phPEL {
  width: 100%;
}

.MasterDetailLayout-module__cursor-pointer___rHm82 {
  cursor: pointer;
}

.MasterDetailLayout-module__cursor-not-allowed___RMFg0 {
  cursor: not-allowed !important;
}

.MasterDetailLayout-module__absolute-centered___HQRTy {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MasterDetailLayout-module__absolute___Oppr4 {
  position: absolute;
}

.MasterDetailLayout-module__relative___an_0C {
  position: relative;
}

.MasterDetailLayout-module__fixed___ic4Vd {
  position: fixed;
}

.MasterDetailLayout-module__visible___PtRAr {
  opacity: 1;
}

.MasterDetailLayout-module__invisible___g1uHA {
  opacity: 0;
}

.MasterDetailLayout-module__col-90___C9fHE {
  width: 90% !important;
}

.MasterDetailLayout-module__col-auto___YIG_w {
  width: auto !important;
}

.MasterDetailLayout-module__medical-tabs___iUhij {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MasterDetailLayout-module__medical-table-new___X0Vfo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo::-webkit-scrollbar-track {
  display: none;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo.MasterDetailLayout-module__no-pagination___Ik7M0 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo.MasterDetailLayout-module__no-pagination___Ik7M0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo.MasterDetailLayout-module__no-pagination___Ik7M0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MasterDetailLayout-module__medical-table-new___X0Vfo.MasterDetailLayout-module__no-pagination___Ik7M0::-webkit-scrollbar-track {
  display: none;
}

.MasterDetailLayout-module__medical-table-empty___Q4YQw {
  padding: 14px 40px !important;
}

.MasterDetailLayout-module__icon-btn___h5KME {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MasterDetailLayout-module__search-icon___xiVHz {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MasterDetailLayout-module__disable-select___Zph5R {
  user-select: none;
}

.MasterDetailLayout-module__break-word___H2qFG {
  word-break: break-word;
}

.MasterDetailLayout-module__popup-clear-btn___vDD5y {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MasterDetailLayout-module__scroll-m-b-20___VZY1Z {
  scroll-margin-bottom: 20px;
}

.MasterDetailLayout-module__root___yk7qU {
  display: flex;
  flex: 1;
  z-index: 2;
  overflow: hidden;
  background-color: #fcfbfb;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MasterDetailLayout/MasterDetailLayout.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.root {\n  display: flex;\n  flex: 1;\n  z-index: 2;\n  overflow: hidden;\n  background-color: get-color(gray, ultra-light-gray);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MasterDetailLayout-module__font-s-10___f1kkZ`,
	"fontS12": `MasterDetailLayout-module__font-s-12___KEUFA`,
	"fontS13": `MasterDetailLayout-module__font-s-13___H9nCJ`,
	"fontS14": `MasterDetailLayout-module__font-s-14___L398y`,
	"fontS15": `MasterDetailLayout-module__font-s-15___qLhhG`,
	"fontS16": `MasterDetailLayout-module__font-s-16___gOVQ2`,
	"fontS18": `MasterDetailLayout-module__font-s-18___FQDdp`,
	"fontS20": `MasterDetailLayout-module__font-s-20___xmutO`,
	"fontS22": `MasterDetailLayout-module__font-s-22___Gwpuy`,
	"fontS28": `MasterDetailLayout-module__font-s-28___NPkrS`,
	"fontW400": `MasterDetailLayout-module__font-w-400___pu2af`,
	"fontW500": `MasterDetailLayout-module__font-w-500___lurSk`,
	"fontW600": `MasterDetailLayout-module__font-w-600___bBvKj`,
	"fontW700": `MasterDetailLayout-module__font-w-700___JD3sY`,
	"p5": `MasterDetailLayout-module__p-5___zUOlF`,
	"p12": `MasterDetailLayout-module__p-12___RUNEr`,
	"p16": `MasterDetailLayout-module__p-16___ombPw`,
	"p30": `MasterDetailLayout-module__p-30___BlgYu`,
	"pB0": `MasterDetailLayout-module__p-b-0___zqGoH`,
	"pB5": `MasterDetailLayout-module__p-b-5___N3hvW`,
	"pB10": `MasterDetailLayout-module__p-b-10___mHcw8`,
	"pB12": `MasterDetailLayout-module__p-b-12___XZomc`,
	"pB16": `MasterDetailLayout-module__p-b-16___U7GKR`,
	"pB18": `MasterDetailLayout-module__p-b-18___EPefQ`,
	"pB20": `MasterDetailLayout-module__p-b-20___AkqLG`,
	"pB25": `MasterDetailLayout-module__p-b-25___pSPzm`,
	"pB30": `MasterDetailLayout-module__p-b-30___kCfnj`,
	"pB50": `MasterDetailLayout-module__p-b-50___W9nqT`,
	"pT0": `MasterDetailLayout-module__p-t-0___S8rGP`,
	"pT12": `MasterDetailLayout-module__p-t-12___vDThY`,
	"pT16": `MasterDetailLayout-module__p-t-16___SUV1J`,
	"pT18": `MasterDetailLayout-module__p-t-18___A4Q0p`,
	"pT20": `MasterDetailLayout-module__p-t-20___lwq2n`,
	"pT30": `MasterDetailLayout-module__p-t-30___XUNK0`,
	"pT40": `MasterDetailLayout-module__p-t-40___fL79s`,
	"pT50": `MasterDetailLayout-module__p-t-50___SVOhH`,
	"pL20": `MasterDetailLayout-module__p-l-20___2G5Xz`,
	"pL30": `MasterDetailLayout-module__p-l-30___nVThM`,
	"pL40": `MasterDetailLayout-module__p-l-40___tAIYC`,
	"pR16": `MasterDetailLayout-module__p-r-16___xXowR`,
	"pR20": `MasterDetailLayout-module__p-r-20___bqeVi`,
	"pR30": `MasterDetailLayout-module__p-r-30___oTbdU`,
	"pR50": `MasterDetailLayout-module__p-r-50___wBLDg`,
	"pR60": `MasterDetailLayout-module__p-r-60___K1js5`,
	"mB1": `MasterDetailLayout-module__m-b-1___FAeZX`,
	"mB2": `MasterDetailLayout-module__m-b-2___WuxGO`,
	"mB6": `MasterDetailLayout-module__m-b-6___sy49I`,
	"mB8": `MasterDetailLayout-module__m-b-8___SL7z2`,
	"mB10": `MasterDetailLayout-module__m-b-10___R9Xby`,
	"mB14": `MasterDetailLayout-module__m-b-14___ZEW3V`,
	"mB16": `MasterDetailLayout-module__m-b-16___xXX9X`,
	"mB20": `MasterDetailLayout-module__m-b-20___Ib3q9`,
	"mB22": `MasterDetailLayout-module__m-b-22___YZQS9`,
	"mB24": `MasterDetailLayout-module__m-b-24___yYVnP`,
	"mB30": `MasterDetailLayout-module__m-b-30___r6EBj`,
	"mB32": `MasterDetailLayout-module__m-b-32___u8gcs`,
	"mB40": `MasterDetailLayout-module__m-b-40___TNqM9`,
	"mT2": `MasterDetailLayout-module__m-t-2___RaZ6r`,
	"mT3": `MasterDetailLayout-module__m-t-3___b4pka`,
	"mT4": `MasterDetailLayout-module__m-t-4___B4kW4`,
	"mT5": `MasterDetailLayout-module__m-t-5___RqwPD`,
	"mT8": `MasterDetailLayout-module__m-t-8___w7FjC`,
	"mT10": `MasterDetailLayout-module__m-t-10___Q9qMq`,
	"mT15": `MasterDetailLayout-module__m-t-15___XBDbF`,
	"mT16": `MasterDetailLayout-module__m-t-16___jcIro`,
	"mT20": `MasterDetailLayout-module__m-t-20___UVVVz`,
	"mT22": `MasterDetailLayout-module__m-t-22___BgJpP`,
	"mT30": `MasterDetailLayout-module__m-t-30___I8yc7`,
	"mT32": `MasterDetailLayout-module__m-t-32___y7642`,
	"mLAuto": `MasterDetailLayout-module__m-l-auto___OiuJx`,
	"mL4": `MasterDetailLayout-module__m-l-4___RTR0L`,
	"mL5": `MasterDetailLayout-module__m-l-5___tZlnv`,
	"mL6": `MasterDetailLayout-module__m-l-6___TWMBU`,
	"mL8": `MasterDetailLayout-module__m-l-8___TKU6M`,
	"mL10": `MasterDetailLayout-module__m-l-10___KuYbR`,
	"mL16": `MasterDetailLayout-module__m-l-16___wobCp`,
	"mL20": `MasterDetailLayout-module__m-l-20____XmW9`,
	"mL24": `MasterDetailLayout-module__m-l-24___YnAYn`,
	"mL30": `MasterDetailLayout-module__m-l-30___Jce01`,
	"mL35": `MasterDetailLayout-module__m-l-35___GcBXg`,
	"mL40": `MasterDetailLayout-module__m-l-40___owmNV`,
	"mR8": `MasterDetailLayout-module__m-r-8___gaIao`,
	"mR10": `MasterDetailLayout-module__m-r-10___HfTJP`,
	"mR16": `MasterDetailLayout-module__m-r-16___zUffO`,
	"mR20": `MasterDetailLayout-module__m-r-20___qpjXy`,
	"mR24": `MasterDetailLayout-module__m-r-24___S9uiy`,
	"mR30": `MasterDetailLayout-module__m-r-30___dWTgZ`,
	"mR40": `MasterDetailLayout-module__m-r-40___f_OTK`,
	"borderR3": `MasterDetailLayout-module__border-r-3___BdtmV`,
	"borderR4": `MasterDetailLayout-module__border-r-4___xKZ9w`,
	"borderR6": `MasterDetailLayout-module__border-r-6___drQSu`,
	"borderR10": `MasterDetailLayout-module__border-r-10___xykr6`,
	"borderR12": `MasterDetailLayout-module__border-r-12___zUC50`,
	"borderR16": `MasterDetailLayout-module__border-r-16___J5Xny`,
	"borderR50": `MasterDetailLayout-module__border-r-50___qRcaH`,
	"primaryBorder": `MasterDetailLayout-module__primary-border___nBNRR`,
	"primaryBorderB": `MasterDetailLayout-module__primary-border-b___mmyIt`,
	"primaryBorderT": `MasterDetailLayout-module__primary-border-t___RzGGx`,
	"primaryBorderL": `MasterDetailLayout-module__primary-border-l___sI5fc`,
	"primaryBorderR": `MasterDetailLayout-module__primary-border-r___KEjr8`,
	"secondaryBorder": `MasterDetailLayout-module__secondary-border___gUZup`,
	"secondaryBorderB": `MasterDetailLayout-module__secondary-border-b___Kl7X4`,
	"secondaryBorderT": `MasterDetailLayout-module__secondary-border-t___Ffs92`,
	"secondaryBorderL": `MasterDetailLayout-module__secondary-border-l___Yp_L1`,
	"secondaryBorderR": `MasterDetailLayout-module__secondary-border-r___O1tK2`,
	"gap0": `MasterDetailLayout-module__gap-0___MZ1Fi`,
	"gap2": `MasterDetailLayout-module__gap-2___a2r1I`,
	"gap4": `MasterDetailLayout-module__gap-4___DHbsI`,
	"gap5": `MasterDetailLayout-module__gap-5___KpdP0`,
	"gap6": `MasterDetailLayout-module__gap-6___xqf09`,
	"gap8": `MasterDetailLayout-module__gap-8___jxSro`,
	"gap10": `MasterDetailLayout-module__gap-10___aFISO`,
	"gap12": `MasterDetailLayout-module__gap-12___tKbf4`,
	"gap14": `MasterDetailLayout-module__gap-14___epr_g`,
	"gap16": `MasterDetailLayout-module__gap-16___PkM5W`,
	"gap18": `MasterDetailLayout-module__gap-18___ocETe`,
	"gap20": `MasterDetailLayout-module__gap-20___ukaq2`,
	"gap24": `MasterDetailLayout-module__gap-24___stBTH`,
	"gap26": `MasterDetailLayout-module__gap-26___ps_pV`,
	"gap30": `MasterDetailLayout-module__gap-30___ppLuj`,
	"gap32": `MasterDetailLayout-module__gap-32___Mt4xs`,
	"gap40": `MasterDetailLayout-module__gap-40___nB7yV`,
	"gap50": `MasterDetailLayout-module__gap-50___jmWRf`,
	"flex1": `MasterDetailLayout-module__flex-1___D4Klu`,
	"flexNone": `MasterDetailLayout-module__flex-none___h2gWh`,
	"flexColumn": `MasterDetailLayout-module__flex-column___wUeUu`,
	"flexRow": `MasterDetailLayout-module__flex-row___M5KsP`,
	"verticallyCentered": `MasterDetailLayout-module__vertically-centered___qG8Ka`,
	"horizontallyCentered": `MasterDetailLayout-module__horizontally-centered___B84NG`,
	"horizontallyEnd": `MasterDetailLayout-module__horizontally-end___E2KUq`,
	"verticallyStart": `MasterDetailLayout-module__vertically-start___qy6kb`,
	"spaceBetween": `MasterDetailLayout-module__space-between___Hza4e`,
	"flexWrap": `MasterDetailLayout-module__flex-wrap___S6uOF`,
	"height100": `MasterDetailLayout-module__height-100___eEAYm`,
	"width50": `MasterDetailLayout-module__width-50___v9L8U`,
	"width100": `MasterDetailLayout-module__width-100___phPEL`,
	"cursorPointer": `MasterDetailLayout-module__cursor-pointer___rHm82`,
	"cursorNotAllowed": `MasterDetailLayout-module__cursor-not-allowed___RMFg0`,
	"absoluteCentered": `MasterDetailLayout-module__absolute-centered___HQRTy`,
	"absolute": `MasterDetailLayout-module__absolute___Oppr4`,
	"relative": `MasterDetailLayout-module__relative___an_0C`,
	"fixed": `MasterDetailLayout-module__fixed___ic4Vd`,
	"visible": `MasterDetailLayout-module__visible___PtRAr`,
	"invisible": `MasterDetailLayout-module__invisible___g1uHA`,
	"col90": `MasterDetailLayout-module__col-90___C9fHE`,
	"colAuto": `MasterDetailLayout-module__col-auto___YIG_w`,
	"medicalTabs": `MasterDetailLayout-module__medical-tabs___iUhij`,
	"medicalTableNew": `MasterDetailLayout-module__medical-table-new___X0Vfo`,
	"noPagination": `MasterDetailLayout-module__no-pagination___Ik7M0`,
	"medicalTableEmpty": `MasterDetailLayout-module__medical-table-empty___Q4YQw`,
	"iconBtn": `MasterDetailLayout-module__icon-btn___h5KME`,
	"searchIcon": `MasterDetailLayout-module__search-icon___xiVHz`,
	"disableSelect": `MasterDetailLayout-module__disable-select___Zph5R`,
	"breakWord": `MasterDetailLayout-module__break-word___H2qFG`,
	"popupClearBtn": `MasterDetailLayout-module__popup-clear-btn___vDD5y`,
	"scrollMB20": `MasterDetailLayout-module__scroll-m-b-20___VZY1Z`,
	"root": `MasterDetailLayout-module__root___yk7qU`
};
module.exports = ___CSS_LOADER_EXPORT___;
